export const parseStringToNumber = (value: string) => parseInt(value.replace(/\D/g, ''), 10) || 0;
